import $ from 'jquery';
import {getWidth, onResize} from "../utils/window";

function setupOverCards(cards) {
	cards.each(function(index){
		const _this = $(this);
		let body = _this.find('.card_content_body');

		_this.on('mouseover', function(){
			body.slideDown(400);
		});

		_this.on('mouseleave', function(){
			body.slideUp(400);
		});
	});
}

function setupNewsCards() {
	let cards = $('.card.-style-news');
	cards.each(function(index){
		const _this = $(this);
		const cardContent = _this.find('.card_content');

		let sub = getWidth() > 815 ? 72 : 35;

		let width = cardContent.outerWidth() - sub;
		cardContent.css('min-height', width + 'px');
	});
}

export default function cards() {
	const $html = $('html');
	const $scroller = $('html, body');

	const cardsOver = $('.card.-style-over');
	const cardsNews = $('.card.-style-news');

	if (cardsOver.length) {
		setupOverCards(cardsOver);
	}

	if (!$('.-insights').hasClass('is-selected')) {
		setupNewsCards(cardsNews);
	}

	onResize(()=>{
		if (cardsOver.length) {
			setupOverCards(cardsOver);
		}

		if (cardsNews.length) {
			if (!$('.-insights').hasClass('is-selected')) {
				setupNewsCards(cardsNews);
			}
		}
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/cards.js